import React from 'react'

const React_Coding_Practice_43 = () => {
  return (
    <div>
      <h1>Coding Pratice 43</h1>
    </div>
  )
}

export default React_Coding_Practice_43
